import { render, staticRenderFns } from "./WikiTooltip.vue?vue&type=template&id=0706b04f"
import script from "./WikiTooltip.vue?vue&type=script&lang=ts"
export * from "./WikiTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports